(function () {
  'use strict';
  if (window.livishProductCardInit) return;
  window.livishProductCardInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var syncTimer = null;

  // The theme binds its notify-me popup only on page load, so cards rendered later
  // (filters, tabs, sliders) need to be bound on first click.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-livish-notify]');
    if (!btn || btn.classList.contains('t4s-mfp-enabled')) return;
    event.preventDefault();
    if (window.T4SThemeSP && typeof window.T4SThemeSP.PopupMFP === 'function') {
      window.T4SThemeSP.PopupMFP();
      if (btn.classList.contains('t4s-mfp-enabled')) btn.click();
    }
  });

  /* ---------- In-cart quantity stepper ---------- */

  function applyCart(cart) {
    var byProduct = {};
    (cart.items || []).forEach(function (item) {
      var entry = byProduct[item.product_id] || (byProduct[item.product_id] = { qty: 0, key: item.key });
      entry.qty += item.quantity;
    });

    document.querySelectorAll('[data-livish-cart]').forEach(function (el) {
      var entry = byProduct[el.dataset.productId];
      var qty = entry ? entry.qty : 0;
      el.dataset.lineKey = entry ? entry.key : '';
      el.classList.toggle('is--in-cart', qty > 0);
      el.classList.toggle('is--single', qty === 1);
      var value = el.querySelector('[data-livish-qty-value]');
      if (value) value.textContent = qty;
    });
  }

  function syncFromServer() {
    if (!document.querySelector('[data-livish-cart]')) return;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(applyCart)
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFromServer, 150);
  }

  function notify(message) {
    if (message && window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
      window.T4SThemeSP.Notices(message);
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-livish-qty-change]');
    if (!btn) return;
    event.preventDefault();
    var wrap = btn.closest('[data-livish-cart]');
    if (!wrap || !wrap.dataset.lineKey || wrap.classList.contains('is--busy')) return;

    var current = parseInt(wrap.querySelector('[data-livish-qty-value]').textContent, 10) || 0;
    var next = Math.max(0, current + parseInt(btn.dataset.livishQtyChange, 10));

    wrap.classList.add('is--busy');
    nativeFetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: wrap.dataset.lineKey, quantity: next })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          notify(result.data.description || result.data.message);
          syncFromServer();
          return;
        }
        applyCart(result.data);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(syncFromServer)
      .finally(function () { wrap.classList.remove('is--busy'); });
  });

  /* Watch cart requests made by the theme or apps (add to cart, mini cart edits) */
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(window, arguments);
    if (CART_URL_RE.test(url)) promise.then(scheduleSync, function () {});
    return promise;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL_RE.test(String(url))) this.addEventListener('loadend', scheduleSync);
    return nativeOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncFromServer();
  });
})();
